import { render, staticRenderFns } from "./ConfigurationDialog.vue?vue&type=template&id=0b630e94&scoped=true&lang=pug&"
import script from "./ConfigurationDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationDialog.vue?vue&type=style&index=0&id=0b630e94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b630e94",
  null
  
)

export default component.exports